import { render } from "./SearchUserByTextContent.vue?vue&type=template&id=495b3e8c&scoped=true"
import script from "./SearchUserByTextContent.vue?vue&type=script&lang=js"
export * from "./SearchUserByTextContent.vue?vue&type=script&lang=js"

import "./SearchUserByTextContent.vue?vue&type=style&index=0&id=495b3e8c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495b3e8c"]])

export default __exports__